module.exports = __webpack_public_path__ + "static/media/factionlandingbackground.af822e40.jpg";